import { jsx as i } from "react/jsx-runtime";
import T from "clsx";
import { toast as s, ToastContainer as y } from "react-toastify";
import { CloseButton as c } from "./CloseButton.js";
import { Toast as C } from "./Toast.js";
import r from "./Toast.module.css.js";
import { Info as I } from "../../foundations/icons/Info.js";
import { Warning as g } from "../../foundations/icons/Warning.js";
import { ErrorIcon as v } from "../../foundations/icons/Error.js";
import { Success as x } from "../../foundations/icons/Success.js";
const a = ({
  closeToast: t,
  data: n
}) => {
  if (!n)
    return null;
  const { title: e, description: o } = n;
  return /* @__PURE__ */ i(
    C,
    {
      title: e,
      description: o instanceof Function ? o({ closeToast: t }) : o
    }
  );
}, O = {
  success: x,
  error: v,
  warning: g,
  info: I
}, m = (t) => {
  const n = O[t];
  return /* @__PURE__ */ i("div", { className: r.typeIcon, children: /* @__PURE__ */ i(n, { size: "20px" }) });
}, E = ({
  type: t,
  title: n,
  description: e,
  onClick: o,
  autoClose: f = 5e3,
  closeVisible: l = !0,
  draggable: u = !0,
  toastId: p,
  containerId: d
}) => s(a, {
  type: t,
  icon: m(t),
  closeButton: !!l && c,
  autoClose: f,
  closeOnClick: typeof o == "function",
  pauseOnHover: !1,
  draggable: u,
  onClick: o,
  toastId: p,
  containerId: d,
  data: { title: n, description: e }
}), F = (t) => {
  s.dismiss(t);
}, H = (t) => s.isActive(t), S = (t, { title: n, description: e, ...o }) => {
  s.update(t, {
    ..."onClick" in o ? { closeOnClick: typeof o.onClick == "function" } : {},
    ..."closeVisible" in o ? { closeButton: !!o.closeVisible && c } : {},
    ..."type" in o && o.type ? { icon: m(o.type) } : {},
    ...typeof n < "u" ? { data: { title: n, description: e }, render: a } : {},
    ...o
  });
}, W = ({
  containerId: t,
  position: n = "top-right",
  className: e = "toast-container"
}) => /* @__PURE__ */ i(
  y,
  {
    limit: 3,
    newestOnTop: !0,
    containerId: t,
    position: n,
    className: T(r.toastContainer, e)
  }
);
export {
  W as ToastContainer,
  F as dismissToast,
  H as isToastActive,
  E as showToast,
  S as updateToast
};
//# sourceMappingURL=index.js.map
